import React, {useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate, useParams, useSearchParams} from 'react-router-dom';
import {Box, Container, Text} from '@tenancy.nz/ui';
import SectionHeader from '../../components/SectionHeader';
import {useInitAgencyBySlugQuery} from '../../api/main/agency';
import {setShowSimilar} from './listingSlice';
import {env, preparePropertyListProps} from '../../utils/helpers';
import PropertyItem from '../../components/PropertyItem';
import PropertyList from '../../components/PropertyList';

function SimilarListingsFeature() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const {id} = useParams();
  const {showSimilar} = useSelector(state => state.listing);

  const {data: {prepared} = {prepared: {}}, isLoading} =
    useInitAgencyBySlugQuery(id, {
      skip: !showSimilar || !id,
    });
  const {agency, property} = prepared;

  const {data: {properties} = {properties: []}} = useInitAgencyBySlugQuery(
    `tps${agency?.clientCode}`,
    {
      skip: !showSimilar || !id || !agency?.clientCode,
    }
  );

  const filtered = useMemo(() => {
    const preped = preparePropertyListProps(properties);
    return preped
      .filter(p => p.id !== property.id)
      .filter(p => {
        const sameOrHigherBedrooms = p.bedrooms >= property.bedrooms;
        return (
          Math.abs(p.rentAmount - property.rentAmount) <= 100 &&
          sameOrHigherBedrooms
        );
      });
  }, [properties, property]);

  if (!showSimilar || filtered.length === 0) {
    return null;
  }

  return (
    <Container maxWidth="lg" sx={{my: 6}}>
      <SectionHeader
        heading={`Similar properties from ${agency?.companyName || ''}`}
      />
      <PropertyList
        items={filtered}
        loading={isLoading}
        renderItem={({
          id: propId,
          rent,
          mediumphoto,
          dateAvailableDisplay,
          ...rest
        }) => (
          <PropertyItem
            {...rest}
            photo={mediumphoto}
            rentAmount={rent}
            dateAvailable={dateAvailableDisplay}
            onView={() => {
              dispatch(setShowSimilar(false));
              navigate(`/listing/${propId}?${searchParams.toString()}`);
            }}
          />
        )}
      />
      <Box textAlign="center" mt={8}>
        <Text paragraph>
          To browse all of {agency?.companyName || 'this agency'}’s
          properties,&nbsp;
          <a
            href={`${env('REACT_APP_URL')}/tps${agency?.clientCode}`}
            rel="noreferrer">
            please click here
          </a>
          .
        </Text>
      </Box>
    </Container>
  );
}

export default SimilarListingsFeature;
